<template>
  <b-modal size="md" title="Konfirmasi Aktivasi" hide-header-close id="urgent-active" centered>
    <div>
      <p>
        {{ $t('notification.alert.notificationSetting') }}
      </p>
      <ul>
        <li>
          {{ $t('notification.alert.notificationImportant') }}
        </li>
        <li>
          {{ $t('notification.alert.allNotificationUrgent') }}
        </li>
        <li>
          {{ $t('notification.alert.impactAllUser') }}
          <span class="blue-500">{{ domainName }}</span>
        </li>
      </ul>
    </div>
    <template #modal-footer="{ cancel }">
      <b-row class="mc-modal__filter-footer mx-0">
        <b-col sm="12" md="12" class="mc-modal__filter-footer-btn">
          <McButton
            variant="outline-primary"
            @click="cancel()"
            class="me-2"
            :text="$t('global.action.cancel')"
          />
          <McButton variant="primary" @click="openModal" :text="$t('global.alert.text.confirm')" />
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>
<script>
import McButton from '@/components/McButton'
import { mapActions } from 'vuex'
import { store as storeAddonSpecific } from '@/services/rest-api/lib/addon-specific/addon-specific'
export default {
  components: {
    McButton,
  },
  computed: {
    domainName() {
      const storeDomain = this.$store.state.identity?.whoami?.domainName
      const storedDomain = localStorage.getItem('domainName')
      if (storeDomain) return storeDomain
      if (storedDomain && storedDomain !== 'undefined') return storedDomain
      return window.location.host
    },
  },
  methods: {
    ...mapActions('modal', ['openSuccessModal']),
    async openModal() {
      try {
        const res = await storeAddonSpecific({
          module: 'e4-alert-center',
          submodule: 'e4e-alert-center-urgent',
        })
        if (res?.message === 'Data Duplicate') {
          this.$emit('hideUrgentInfo')
          this.$mcToast?.warning(this.$t('notification.text.duplicated'))
          return
        } else if (res?.errors) {
          this.$mcToast?.error(res?.message)
          return
        }

        if (res.status === true) {
          this.$emit('hideUrgentInfo')
          this.openSuccessModal()
        }
      } catch (error) {
        console.log('error', error)
      } finally {
        await this.$store.dispatch('identity/init')
        this.$bvModal.hide('urgent-active')
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.embed-responsive {
  iframe {
    width: 100%;
    height: 250px;
  }
}
</style>
